export function setContentListData(data) {
  return {
    type: 'SET_CONTENT',
    data
  };
}

export function setSearchListData(data) {
  return {
    type: 'SET_SEARCH_CONTENT',
    data
  };
}

export function setSearchListEmpty() {
  return {
    type: 'SET_SEARCH_CONTENT_EMPTY'
  };
}

export function setSelectedContent(data) {
  return {
    type: 'SET_SELECTED_CONTENT',
    data
  };
}
